<template>
    <div :class="getCSSClass('filing-data-component-container')">
        <template v-if="subject">
        <div v-if="subject.name_and_workflow_number"
             :class="getCSSClass('filing-data-file-label')"
             v-html="subject.name_and_workflow_number"></div>
        </template>
        <label v-html="translate('Munkaszám')"></label>
        <component-wrapper-with-add-button
                style="width: 100%;"
                v-model="worknumber"
                :auto-emit="true"
                v-bind="listProps"></component-wrapper-with-add-button>
        <label v-html="translate('Iktatási sorszámban szereplő év')"></label>
        <input type="text" v-model="year" :class="getCSSClass('filing-data-component-year-input')">
        <label v-html="translate('Iktatott dokumentum(ok) fizikai helye')"></label>
        <input type="text" v-model="physical_location" :class="getCSSClass('filing-data-component-physical_location-input')">
        <label v-html="translate('Dokumentum főkönyvi száma')"></label>
        <input type="text" v-model="book_number" :class="getCSSClass('filing-data-component-book_number-input')">
        <label v-html="translate('Kapcsolódó munkaszámok')"></label>
        <component-wrapper-with-add-button
            style="width: 100%;"
            v-model="relatedworkflownumbers"
            :auto-emit="true"
            v-bind="relatedProps"></component-wrapper-with-add-button>

    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            urls: {type: Object},
            subject: {},
        },
        data: function () {
            return {
                worknumber: null,
                year: null,
                physical_location: '',
                book_number: null,
                relatedworkflownumbers: [],
            }
        },
        created() {
            this.year = (new Date()).getFullYear().toString().substring(2);
        },
        mounted() {
            if (this.subject) {
                if (this.subject.workflownumber_id) {
                    this.worknumber = this.subject.workflownumber_id;
                }
                if (this.subject.physical_place_of_registered_document) {
                    this.physical_location = this.subject.physical_place_of_registered_document;
                }
                if (this.subject.year_of_registration) {
                    this.year = this.subject.year_of_registration;
                }
                if (this.subject.book_number) {
                    this.book_number = this.subject.book_number;
                }
                if (this.subject.relatedworkflownumbers) {
                    this.relatedworkflownumbers = this.subject.relatedworkflownumbers.map(w => w.workflownumber_id);
                }
            }
        },
        methods: {},
        computed: {
            formData: function() {
                return {
                    worknumber: this.worknumber,
                    year: this.year,
                    physical_location: this.physical_location,
                    book_number: this.book_number,
                    relatedworkflownumbers: this.relatedworkflownumbers
                }
            },
            listProps: function() {
                return {
                    subComponent: 'SearchableSelect',
                    subComponentValuesetProp: 'valueset',
                    formUrl: this.urls.formUrl,
                    storeUrl: this.urls.storeUrl,
                    fetchUrl: this.urls.fetchUrl,
                    addButtonHTML: this.icon('plus')+this.translate('Hozzáadás'),
                    defaultSubComponentProps: {
                        multiple: false,
                        respectDisabledAttribute: true,
                        buttons: this.mainButtons,
                        labelProperty: 'wntext_label',
                        revertXOpening: false
                    }
                }
            },
            relatedProps: function() {
                return {
                    subComponent: 'SearchableSelect',
                    subComponentValuesetProp: 'valueset',
                    formUrl: this.urls.formUrl,
                    storeUrl: this.urls.storeUrl,
                    fetchUrl: this.urls.fetchUrl,
                    addButtonHTML: this.icon('plus')+this.translate('Hozzáadás'),
                    defaultSubComponentProps: {
                        multiple: true,
                        respectDisabledAttribute: true,
                        buttons: this.mainButtons,
                        labelProperty: 'wntext_label',
                        revertXOpening: false
                    }
                }
            }

        },
        watch: {
            formData: function() {
                this.$emit('input', this.formData);
            },
            year: function(value) {
                if (value.length > 2) {
                    this.year = value.substring(0,2);
                }
            }
        }

    }
</script>
